import { ModulesStatesEnum } from "@/routes/area-aggregate/types/enums/modules-states.enum";
import { ModuleCommandEnum } from "@/types/enums/module-command.enum";

export const getStateToDisplayForCommand = (command: ModuleCommandEnum) => {
  let resultState: ModulesStatesEnum | null = null;
  switch (command) {
    case ModuleCommandEnum.UP:
      resultState = ModulesStatesEnum.UP;
      break;
    case ModuleCommandEnum.DOWN:
      resultState = ModulesStatesEnum.FOLDED;
      break;
    case ModuleCommandEnum.OPEN:
      resultState = ModulesStatesEnum.UNFOLDED;
      break;
    case ModuleCommandEnum.CLOSE:
      resultState = ModulesStatesEnum.UP;
      break;
  }

  if (!resultState) {
    throw new Error("No state found");
  }

  return resultState;
};
